import { amplifyProxy, directApi } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    RStBReport: '',
    loading: {
      report: false,
      export: false
    },
    error: {
      report: null,
      export: null
    }
  },
  mutations: {
    SET_RSTB(state, data) {
      state.RStBReport = data
    },
    SET_LOADING(state, { type, value }) {
      state.loading[type] = value
    },
    SET_ERROR(state, { type, error }) {
      state.error[type] = error
    }
  },
  actions: {
    async getRStB({ commit, rootState }, payload) {
      commit('SET_LOADING', { type: 'report', value: true })
      commit('SET_ERROR', { type: 'report', error: null })
      
      try {
        const endpoint = `/${rootState.user.ClientName}/reporting/RStB`
        const options = {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            monthToSearch: payload
          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        commit('SET_RSTB', response.data.Results)
        return response.data.Results
      } catch (error) {
        commit('SET_ERROR', { type: 'report', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'report', value: false })
      }
    },

    async exportRStB({ commit, rootState }, payload) {
      commit('SET_LOADING', { type: 'export', value: true })
      commit('SET_ERROR', { type: 'export', error: null })

      try {
        const endpoint = `/${rootState.user.ClientName}/reporting/RStB/export`
        const queryParams = {
          branchID: rootState.branchID,
          monthToSearch: payload
        }

        await directApi.exportCsv(
          rootState.user.ClientName,
          endpoint,
          queryParams,
          'RStBexport.CSV',
          rootState.user.LoginToken
        )

        return { success: true }
      } catch (error) {
        commit('SET_ERROR', { type: 'export', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'export', value: false })
      }
    }
  }
}